// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--font-family-base:\"Nunito\",sans-serif;--font-size:13px;--font-size-header:28px;--hover-color:#337ab7;--brand-color:#337ab7;--border-color:#ddd;--notification-color:#ff5a5f;--max-content-width:1000px;--screen-xs-min:480px;--screen-sm-min:768px;--screen-md-min:992px;--screen-lg-min:1200px}line{stroke-opacity:.6}circle{stroke-width:1px;stroke:#aaa;fill:#fff;cursor:pointer}text{font-family:Nunito,sans-serif;font-family:var(--font-family-base);font-size:14px;font-size:calc(var(--font-size) + 1px)}text,text._3yNe2{font-weight:700}line._21Pvq,path{stroke-opacity:.6}circle._2isaq{stroke-width:2px;stroke:#aaa;fill:#fff}circle._1v1UW{stroke-width:3px}._1z-Hw{stroke:#00f}._1EyMg{border-bottom:1px solid #ddd;border-bottom:1px solid var(--border-color);padding-bottom:10px;margin-bottom:10px;position:relative;z-index:0}._3cRkH{color:#fff;padding:5px 10px;border-radius:3px}", ""]);
// Exports
exports.locals = {
	"gene-name": "_3yNe2",
	"edge": "_21Pvq",
	"gene": "_2isaq",
	"gene-query": "_1v1UW",
	"shared": "_1z-Hw",
	"root": "_1EyMg",
	"legend": "_3cRkH"
};
module.exports = exports;
